import React, { useState } from "react";
import { testBeforeRender } from "../../../jsxProviders";
import { observer } from "mobx-react-lite";
import { useMst } from "../../../store/root";
import { MainButton } from "../MainButton/MainButton";
import styles from "./RenderButton.module.scss";
import { TextButton } from "../TextButton/TextButton";
import { InfoText } from "../../InfoText/InfoText";

export const RenderButton = observer(() => {
  const [timeoutId, setTimeoutId] = useState<NodeJS.Timeout | null>(null);
  const {
    projectStore: { selectedSceneExists },
    compositionStore: {
      selectedCompositionsName,
      setRenderedCompositions,
      fillQueuedCompositions,
      selectedCompositionsId,
    },
    renderStore: {
      isRendering,
      setProcessIsCancelled,
      cancelRender,
      isCancelling,
      setIgnoreProblemLayers,
    },
    uiStore: {
      setSceneHasDataModalVisible,
      dontAskAgainOverrideSceneData,
      resetProblemLayersData,
    },
  } = useMst();
  /**
   * There are two possible paths from the render button
   * 1.At least one scene has data and !dontAskAgainOverrideSceneData is true
   * 2. Else return testBeforeRender
   * 3. Scene does not exists -> create scene and render
   * @returns the method that will continue the rendering process
   */
  const nextProcess = async () => {
    setRenderedCompositions(null);
    setProcessIsCancelled(false); // Reset before render
    resetProblemLayersData();
    // If one of the scenes has data
    const some = selectedCompositionsName.some(
      (comp) => selectedSceneExists(comp)?.jsonUrl
    );
    if (some && !dontAskAgainOverrideSceneData) {
      return setSceneHasDataModalVisible();
    }
    fillQueuedCompositions(); // Fill the queue with the selected compositions
    return testBeforeRender();
  };

  const handleMouseDown = () => {
    setIgnoreProblemLayers(false); // Reset the hold state
    const timeoutId = setTimeout(() => setIgnoreProblemLayers(true), 2000); // 500ms threshold for hold
    setTimeoutId(timeoutId);
  };
  const handleMouseUp = async () => {
    timeoutId && clearTimeout(timeoutId);
    await nextProcess();
  };
  return (
    <div className={styles.RenderMain}>
      <InfoText>
        Rendered compositions are saved to draft.
        <br /> To publish, continue in Studio.
      </InfoText>
      <div className={styles.Button}>
        {isRendering ? (
          <TextButton
            text={isCancelling ? "Cancelling" : "Cancel Render"}
            onClick={cancelRender}
          />
        ) : (
          <MainButton
            onMouseDown={handleMouseDown}
            onMouseUp={handleMouseUp}
            disabled={isRendering || selectedCompositionsId.length === 0}
            text={"Render"}
          />
        )}
      </div>
    </div>
  );
});
